module.exports = __webpack_public_path__ + "img/background_st.4d6700c3.jpg";